import React from 'react';
import PackageDealForm from './PackageDealForm';
import DisneyCruiseLineForm from './DisneyCruiseLineForm';
import RoyalCaribbeanCruiseForm from './RoyalCaribbeanCruiseForm';
import CarnivalCruiseForm from './CarnivalCruiseForm';
import SimpleComponentForm from './SimpleComponentForm';

const IndependentComponentModal = ({ component, onSave, onCancel }) => {
  const renderForm = () => {
    const componentType = component?.type;

    switch (componentType) {
      case 'package':
        return <PackageDealForm component={component} onSave={onSave} onCancel={onCancel} />;
      case 'disney-cruise-line':
        return <DisneyCruiseLineForm component={component} onSave={onSave} onCancel={onCancel} />;
      case 'royal-caribbean-cruise':
        return <RoyalCaribbeanCruiseForm component={component} onSave={onSave} onCancel={onCancel} />;
      case 'carnival-cruise':
        return <CarnivalCruiseForm component={component} onSave={onSave} onCancel={onCancel} />;
      default:
        // For all other component types, use the simple form
        return <SimpleComponentForm component={component} onSave={onSave} onCancel={onCancel} />;
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        {renderForm()}
      </div>
    </div>
  );
};

export default IndependentComponentModal;
